import "./listrates.css";
import { Link } from "react-router-dom";
import { RatesList } from "src/Components";

const Svg = ({ children, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IcPlus = () => <Svg><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></Svg>;

const ListRates = () => {
  return (
    <div className="rt2-page">
      <header className="rt2-hero">
        <div>
          <span className="rt2-hero__eyebrow">Revenue management</span>
          <h1 className="rt2-hero__title">Rates & offers</h1>
          <p className="rt2-hero__sub">
            Define how rooms are priced and packaged. Rates are the baseline you
            sell every day — offers are the windows where promotions go live.
          </p>
        </div>
        <div className="rt2-hero__actions">
          <Link to="create" className="rt2-btn rt2-btn--primary">
            <IcPlus /> New rate
          </Link>
        </div>
      </header>

      <RatesList />
    </div>
  );
};

export default ListRates;
